/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 */

export const GET_GEOS_SUCCESS = 'GET_GEOS_SUCCESS'
